

import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { listSessions } from '../../api'
import img from '../../assets/brainImg.png'
import img1 from '../../assets/avatars/1.png'
import img2 from '../../assets/dranika.png'
import i3 from '../../assets/avatars/3.png'
import HelixiaSvg from '../../assets/Helixia.svg'
import PoweredBySvg from "../../assets/poweredBy.svg"
function Home() {
  const navigate = useNavigate()
  const [agents, setAgents] = useState([])
  const [loading, setLoading] = useState(true)
  const [currentPage, setCurrentPage] = useState(1)
  const [roleFilter, setRoleFilter] = useState('')
  const [specialtyFilter, setSpecialtyFilter] = useState('')
  const [dragActive, setDragActive] = useState(false)
  const [roleDropdownOpen, setRoleDropdownOpen] = useState(false)
  const [specialtyDropdownOpen, setSpecialtyDropdownOpen] = useState(false)
  
  const agentsPerPage = 4

  useEffect(() => {
    fetchAgents()
  }, [])

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.dropdown-container')) {
        setRoleDropdownOpen(false)
        setSpecialtyDropdownOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const fetchAgents = async () => {
    try {
      setLoading(true)
      const response = await listSessions()
      setAgents(response.agents || [])
    } catch (error) {
      console.error('Error fetching agents:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleDrag = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true)
    } else if (e.type === "dragleave") {
      setDragActive(false)
    }
  }

  const handleDrop = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setDragActive(false)

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFiles(e.dataTransfer.files)
    }
  }

  const handleFiles = (files) => {
    console.log('Files selected:', files)
    // Handle file upload logic here
  }

  const handleFileInput = (e) => {
    if (e.target.files) {
      handleFiles(e.target.files)
    }
  }

  const handleCardClick = (agent) => {
    navigate(`/session/${agent.agent_id}`, {
      state: { agentData: agent }
    })
  }

  const handleUploadClick = (agent) => {
    navigate(`/session/${agent.agent_id}/upload`, {
      state: { agentName: agent.agent_name }
    })
  }

  // Calculate pagination
  const indexOfLastAgent = currentPage * agentsPerPage
  const indexOfFirstAgent = indexOfLastAgent - agentsPerPage
  const currentAgents = agents.slice(indexOfFirstAgent, indexOfLastAgent)
  const totalPages = Math.ceil(agents.length / agentsPerPage)

  // Mock data for analyst details (since API doesn't provide this)
  const getAnalystDetails = (agentName) => {
    const details = {

      'Dr. Anika': {
        role: 'Obesity Specialist Agent',
        specialties: ['Obesity'],
        description: 'Statistical Analysis, Research Methodology',
        image: img2
      },
      'Helixia': {
        role: 'Research Analyst',
        specialties: ['Obesity'],
        description: 'Statistical Analysis, Research Methodology',
        image: img2
      }
      // 'test2': {
      //   role: 'Medical Rep',
      //   specialties: ['Market Research & Competitive Intelligence'],
      //   description: 'Drug mechanisms, pharmacokinetics and safety profiles',
      //   image: img2
      // },
      // 'test': {
      //   role: 'Clinical Analyst',
      //   specialties: ['Clinical Trials & Drug-Efficacy'],
      //   description: 'Deep adverse events analysis, controlled environments',
      //   img: i3
      // }
    }
    return details[agentName] || {
      role: 'Medical Analyst',
      specialties: ['General Medicine'],
      description: 'Comprehensive medical analysis'

    }
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className='w-full bg-white' style={{
        boxShadow: "0px -15px 76.1px rgba(0, 0, 0, 0.07)",
        backdropFilter: "blur(12.15px)",
      }}>
        <section
          className="relative flex flex-col md:flex-row items-center justify-between w-full max-w-[1280px] mx-auto bg-white overflow-hidden px-4 sm:px-6 lg:px-[120px] mt-16 md:mt-[60px] py-6 md:py-8"
        >
          {/* LEFT CONTENT */}
          <div className="flex flex-col justify-center items-start gap-4 relative z-10 w-full md:w-[423px]">
            {/* Logo Placeholder Box */}
            <div
              className="flex items-center justify-center w-[120px] h-[52px] md:w-[145px] md:h-[64px] bg-[#EDE5FE] rounded"
            >
              <img src={HelixiaSvg} alt="Helixia" />
            </div>

            {/* TEXT SECTION */}
            <div className="flex flex-col items-start gap-2 w-full md:w-[423px]">
              {/* Gradient Heading */}
              <h1
                className="font-bold text-3xl sm:text-4xl md:text-[52px] leading-tight md:leading-[63px]"
                style={{
                  fontFamily: "Inter, sans-serif",
                  background: "linear-gradient(89.74deg, #4F39F6 -15.9%, #2E2190 99.77%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                Your AI Medical Analysts Team
              </h1>

              {/* Subtitle */}
              <p
                className="text-gray-600 text-base sm:text-lg md:text-[20px] leading-6"
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 500,
                  letterSpacing: "0.003em",
                }}
              >
                Our AI Specialists simplify complex medical documents into clear insights
              </p>
              <a href="https://curebay.com/" target="_blank" rel="noopener noreferrer">
                <img className='mt-3 w-[107px] h-[34px]' src={PoweredBySvg} alt='Powered By Curebay' />
              </a>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="relative z-30 w-full md:w-auto flex justify-center md:justify-end">
            <img
              src={img}
              alt="AI Brain"
              className="w-full max-w-[320px] sm:max-w-[420px] md:max-w-[520px] lg:max-w-[597px] h-auto"
              style={{
                objectFit: "contain",
                transform: "scaleX(-1)",
              }}
            />
          </div>

          {/* Background Ellipses */}
          <div
            className="absolute pointer-events-none hidden md:block"
            style={{
              width: "591px",
              height: "589px",
              left: "704px",
              top: "-110px",
              background:
                "radial-gradient(50% 50% at 50% 50%, rgba(111, 48, 248, 0.37) 0%, rgba(137, 89, 240, 0.07) 74.34%, rgba(217, 217, 217, 0) 100%)",
              zIndex: 1,
            }}
          />
          <div
            className="absolute pointer-events-none hidden md:block"
            style={{
              width: "773px",
              height: "770px",
              left: "433px",
              top: "52px",
              background:
                "radial-gradient(50% 50% at 50% 50%, rgba(111, 48, 248, 0.37) 0%, rgba(137, 89, 240, 0.07) 74.34%, rgba(217, 217, 217, 0) 100%)",
              opacity: 0.6,
              zIndex: 2,
            }}
          />
        </section>
      </div>

      {/* Analyst Selection Section */}
      <div className="w-full max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-[120px] py-8">
        <div className="p-8">
          {/* Section Header */}
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mb-8">
            <h2 className="text-2xl font-bold text-gray-700">Choose Your Analyst</h2>

            {/* Filter Controls */}
            <div className="flex items-center gap-2 md:gap-4 flex-wrap md:flex-nowrap">
              <span className="text-gray-600">Filter</span>
              
              {/* Role Dropdown */}
              <div className="relative dropdown-container">
                <button
                  onClick={() => {
                    setRoleDropdownOpen(!roleDropdownOpen)
                    setSpecialtyDropdownOpen(false)
                  }}
                  className="bg-[#E5F5EA] text-gray-700 px-4 py-2 rounded-full focus:outline-none w-full md:w-auto flex items-center justify-between gap-2 min-w-[120px]"
                  style={{ backgroundColor: 'rgb(229, 245, 234)' }}
                >
                  <span className="text-sm font-medium">{roleFilter === 'research' ? 'Research Analyst' : roleFilter === 'medical' ? 'Medical Rep' : roleFilter === 'clinical' ? 'Clinical Analyst' : 'Role'}</span>
                  <svg className={`w-4 h-4 transition-transform ${roleDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {roleDropdownOpen && (
                  <div className="absolute top-full left-0 mt-1 bg-white rounded-lg shadow-lg border border-gray-200 z-50 min-w-[200px]">
                    <div className="py-2">
                      <label className="flex items-center px-4 py-3 hover:bg-gray-50 cursor-pointer">
                        <input
                          type="radio"
                          name="role"
                          value="research"
                          checked={roleFilter === 'research'}
                          onChange={(e) => {
                            setRoleFilter(e.target.value)
                            setRoleDropdownOpen(false)
                          }}
                          className="mr-3 w-4 h-4 text-blue-600 focus:ring-blue-500"
                        />
                        <span className="text-gray-700">Obesity Specialist Agent</span>
                      </label>
                      <div className="border-t border-gray-200"></div>
                      <label className="flex items-center px-4 py-3 hover:bg-gray-50 cursor-pointer">
                        <input
                          type="radio"
                          name="role"
                          value="medical"
                          checked={roleFilter === 'medical'}
                          onChange={(e) => {
                            setRoleFilter(e.target.value)
                            setRoleDropdownOpen(false)
                          }}
                          className="mr-3 w-4 h-4 text-blue-600 focus:ring-blue-500"
                        />
                        <span className="text-gray-700">Medical Rep</span>
                      </label>
                      <div className="border-t border-gray-200"></div>
                      <label className="flex items-center px-4 py-3 hover:bg-gray-50 cursor-pointer">
                        <input
                          type="radio"
                          name="role"
                          value="clinical"
                          checked={roleFilter === 'clinical'}
                          onChange={(e) => {
                            setRoleFilter(e.target.value)
                            setRoleDropdownOpen(false)
                          }}
                          className="mr-3 w-4 h-4 text-blue-600 focus:ring-blue-500"
                        />
                        <span className="text-gray-700">Clinical Analyst</span>
                      </label>
                    </div>
                  </div>
                )}
              </div>

              {/* Specialty Dropdown */}
              <div className="relative dropdown-container">
                <button
                  onClick={() => {
                    setSpecialtyDropdownOpen(!specialtyDropdownOpen)
                    setRoleDropdownOpen(false)
                  }}
                  className="bg-[#E5F5EA] text-gray-700 px-4 py-2 rounded-full focus:outline-none w-full md:w-auto flex items-center justify-between gap-2 min-w-[120px]"
                  style={{ backgroundColor: 'rgb(229, 245, 234)' }}
                >
                  <span className="text-sm font-medium">{specialtyFilter === 'obesity' ? 'Diabetic Studies' : specialtyFilter === 'ozempic' ? 'Ozempic' : specialtyFilter === 'market' ? 'Market Research' : specialtyFilter === 'clinical' ? 'Clinical Trials' : 'Speciality'}</span>
                  <svg className={`w-4 h-4 transition-transform ${specialtyDropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                {specialtyDropdownOpen && (
                  <div className="absolute top-full left-0 mt-1 bg-white rounded-lg shadow-lg border border-gray-200 z-50 min-w-[200px]">
                    <div className="py-2">
                      <label className="flex items-center px-4 py-3 hover:bg-gray-50 cursor-pointer">
                        <input
                          type="radio"
                          name="specialty"
                          value="obesity"
                          checked={specialtyFilter === 'obesity'}
                          onChange={(e) => {
                            setSpecialtyFilter(e.target.value)
                            setSpecialtyDropdownOpen(false)
                          }}
                          className="mr-3 w-4 h-4 text-blue-600 focus:ring-blue-500"
                        />
                        <span className="text-gray-700">Diabetic Studies</span>
                      </label>
                      <div className="border-t border-gray-200"></div>
                      <label className="flex items-center px-4 py-3 hover:bg-gray-50 cursor-pointer">
                        <input
                          type="radio"
                          name="specialty"
                          value="ozempic"
                          checked={specialtyFilter === 'ozempic'}
                          onChange={(e) => {
                            setSpecialtyFilter(e.target.value)
                            setSpecialtyDropdownOpen(false)
                          }}
                          className="mr-3 w-4 h-4 text-blue-600 focus:ring-blue-500"
                        />
                        <span className="text-gray-700">Ozempic</span>
                      </label>
                      <div className="border-t border-gray-200"></div>
                      <label className="flex items-center px-4 py-3 hover:bg-gray-50 cursor-pointer">
                        <input
                          type="radio"
                          name="specialty"
                          value="market"
                          checked={specialtyFilter === 'market'}
                          onChange={(e) => {
                            setSpecialtyFilter(e.target.value)
                            setSpecialtyDropdownOpen(false)
                          }}
                          className="mr-3 w-4 h-4 text-blue-600 focus:ring-blue-500"
                        />
                        <span className="text-gray-700">Market Research</span>
                      </label>
                      <div className="border-t border-gray-200"></div>
                      <label className="flex items-center px-4 py-3 hover:bg-gray-50 cursor-pointer">
                        <input
                          type="radio"
                          name="specialty"
                          value="clinical"
                          checked={specialtyFilter === 'clinical'}
                          onChange={(e) => {
                            setSpecialtyFilter(e.target.value)
                            setSpecialtyDropdownOpen(false)
                          }}
                          className="mr-3 w-4 h-4 text-blue-600 focus:ring-blue-500"
                        />
                        <span className="text-gray-700">Clinical Trials</span>
                      </label>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Loading State */}
          {loading ? (
            <div className="flex justify-center items-center h-64">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
            </div>
          ) : (
            <>
              {/* Analyst Cards Grid - Responsive */}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6 mb-8">
                {currentAgents.map((agent) => {
                  const details = getAnalystDetails(agent.agent_name)
                  return (
                    <div 
                      key={agent.agent_id} 
                      className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow cursor-pointer flex flex-col w-full min-h-[376px]"
                      onClick={() => handleCardClick(agent)}
                    >
                      {/* Avatar */}
                      <div className="w-full h-40 sm:h-48 rounded-t-lg overflow-hidden">
                        {details.image ? (
                          <img
                            src={details.image}
                            alt={agent.agent_name}
                            className="w-full h-full object-cover"
                          />
                        ) : (
                          <div className="w-full h-full bg-purple-200 flex items-center justify-center">
                            <span className="text-purple-600 font-bold text-4xl">
                              {agent.agent_name.charAt(0).toUpperCase()}
                            </span>
                          </div>
                        )}
                      </div>

                      <div className="p-6 flex flex-col items-center gap-3 flex-1">
                        {/* Name */}
                        <h3 className="font-bold text-gray-900 text-lg text-center w-full">{agent.agent_name}</h3>
                        
                        {/* Role Tag */}
                        <div className="flex justify-center w-full">
                          <span 
                            className="px-3 py-1 rounded-full text-sm font-medium whitespace-nowrap"
                            style={{ backgroundColor: 'rgb(229, 245, 234)', color: '#1F2937' }}
                          >
                            {details.role || 'Medical Rep'}
                          </span>
                        </div>

                        {/* Product/Specialty - Purple Bold Text */}
                        {details.specialties && details.specialties.length > 0 && (
                          <p className="text-purple-600 font-bold text-base text-center">
                            {details.specialties[0]}
                          </p>
                        )}
                        
                        {/* Separator */}
                        <div className="w-full border-t border-gray-200"></div>
                        
                        {/* Specialisations */}
                        <p className="text-sm text-gray-600 text-center leading-relaxed">
                          <span className="font-medium">Specialises in:</span> {agent.description || details.description}
                        </p>
                      </div>
                    </div>
                  )
                })}
              </div>

              {/* Pagination - ALIGNED */}
              {totalPages > 1 && (
                <div className="flex justify-center items-center space-x-2">
                  <button
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                    className="flex items-center gap-1 px-3 py-2 text-sm text-gray-600 hover:text-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <span>&lt;</span>
                    <span>PREV</span>
                  </button>

                  <div className="flex gap-2">
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                      <button
                        key={page}
                        onClick={() => setCurrentPage(page)}
                        className={`w-8 h-8 rounded-full text-sm ${currentPage === page
                            ? 'bg-gray-200 text-gray-900 font-medium'
                            : 'text-gray-600 hover:bg-gray-100'
                          }`}
                      >
                        {page}
                      </button>
                    ))}
                  </div>

                  <button
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                    className="flex items-center gap-1 px-3 py-2 text-sm text-gray-600 hover:text-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <span>NEXT</span>
                    <span>&gt;</span>
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default Home